/* Lo Esencial cart drawer: AJAX add + line changes via section rendering API */
(function () {
  'use strict';

  var SECTION_ID = 'le-cart-drawer';
  var DRAWER_SELECTOR = '[data-cart-drawer]';
  // Personalización ($49 engraving) is a real, UNLISTED add-on product.
  // handle `custom`, variant 53370846118202. See spec 2026-05-20.
  var PERSO_VARIANT_ID = 53370846118202;
  var PERSO_HANDLE = 'custom';

  function init() {
    wireDrawerToggle();
    wireProductForms();
    wireLineChanges();
    wirePersonalizationEdit();
    wireVariantSwap();
    wireDiscountForm();
    wireGiftRefresh();

    // Defensive: sweep orphan personalización lines on every page load.
    // An orphan is a $49 `custom` line whose `_perso_id` no longer links
    // back to any main product line in the cart (cascade-on-removal
    // failed, a retry succeeded only on the main, etc.). Left in place,
    // these silently overcharge the customer at checkout. LE1030
    // incident 2026-05-25: 3 orphans x $49 = $147 overcharge. Queued so
    // the sweep cannot race a parallel mutation.
    function runSweep(reason) {
      return enqueue(function () {
        return getCart().then(function (cart) {
          if (cart && cart.__sweptOrphans) {
            try {
              console.warn('[cart-drawer] orphan sweep (' + reason + ') purged ' +
                cart.__sweptOrphans + ' personalización line(s)');
            } catch (e) {}
            updateCartCount();
            var openDrawerEl = document.querySelector(DRAWER_SELECTOR + '[open]');
            if (openDrawerEl) refreshDrawerFromServer();
          }
        });
      }).catch(function () {});
    }

    runSweep('init');

    // Adolfo flagged 2026-05-26: customer's checkout had a stale "Para:
    // Simple Sleeve" Personalización line at $49 while their actual cart
    // contained only Traveler (no Simple Sleeve). The init sweep didn't
    // catch it because the page may have been restored from bfcache (back
    // button), the user may have left the tab and returned without a fresh
    // navigation, or a /cart/change.js retry on the orphan failed silently
    // on the original trigger. Multiplying the sweep triggers narrows the
    // window where a stale orphan can survive a session.
    // bfcache restore (back/forward) freezes and restores the entire page DOM
    // (including the cart drawer and its "N objetos" count) WITHOUT re-running
    // scripts. If the customer added items via "Comprar ahora" (which navigates
    // straight to /checkout) and then hit BACK, the restored drawer still shows
    // its pre-add state ("0 objetos") while the server cart actually holds the
    // items. The old handler only refreshed the UI when an orphan was swept, so
    // a legitimate cart gain left the drawer stale. Always re-sync the cart UI
    // from the server on bfcache restore. getCart() still runs the orphan sweep,
    // so this supersedes runSweep for the bfcache path. Adolfo flagged 2026-06-03.
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      enqueue(function () {
        return getCart().then(function (cart) {
          if (cart && cart.__sweptOrphans) {
            try {
              console.warn('[cart-drawer] orphan sweep (pageshow-bfcache) purged ' +
                cart.__sweptOrphans + ' personalización line(s)');
            } catch (e) {}
          }
          updateCartCount();
          return refreshDrawerFromServer();
        });
      }).catch(function () {});
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') runSweep('visibilitychange');
    });
  }

  function wireDrawerToggle() {
    var openers = document.querySelectorAll('[data-cart-toggle]');
    openers.forEach(function (btn) {
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        openDrawer();
      });
    });

    document.addEventListener('click', function (ev) {
      var close = ev.target.closest('[data-cart-close]');
      if (close) {
        ev.preventDefault();
        closeDrawer();
      }
    });
  }

  // iOS-safe body scroll lock. The plain `overflow: hidden` approach
  // does NOT stop touch scroll on iOS Safari, which lets the customer
  // scroll the page behind the drawer. Background scroll also collapses
  // the iOS URL bar, which changes the visual viewport height, which
  // makes the drawer (anchored top:0 bottom:0) appear to grow and
  // shrink as the customer scrolls. The position:fixed + negative top
  // pattern freezes body in place and survives iOS quirks. Spec
  // 2026-05-26 / scroll-lock fix.
  function lockBodyScroll(overrideScrollY) {
    if (document.body.dataset.scrollLocked === '1') return;
    // Allow caller to pass in a pre-captured scroll position so the lock
    // reflects where the user actually was BEFORE any showModal-induced
    // focus shift or browser auto-scroll. Falls back to current window
    // scroll if no override provided.
    var scrollY = (typeof overrideScrollY === 'number')
      ? overrideScrollY
      : (window.scrollY || window.pageYOffset || 0);
    document.body.dataset.scrollLocked = '1';
    document.body.dataset.scrollLockY = String(scrollY);
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  function unlockBodyScroll() {
    if (document.body.dataset.scrollLocked !== '1') return;
    var lockedY = parseInt(document.body.dataset.scrollLockY || '0', 10);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    delete document.body.dataset.scrollLocked;
    delete document.body.dataset.scrollLockY;
    if (lockedY > 0) {
      // Defer to next animation frame so the body's reflow (from removing
      // position:fixed) settles before we restore scroll. Without rAF the
      // browser can interleave its own scroll reset with our scrollTo and
      // the user ends up at the wrong position. behavior:'instant' bypasses
      // any global scroll-behavior:smooth CSS. Adolfo flagged 2026-05-26:
      // closing the cart drawer scrolled the page DOWN automatically from
      // where the user actually was when they opened it.
      var restore = function () {
        try {
          window.scrollTo({ top: lockedY, left: 0, behavior: 'instant' });
        } catch (e) {
          window.scrollTo(0, lockedY);
        }
      };
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(restore);
      } else {
        restore();
      }
    }
  }

  function openDrawer() {
    var drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) return;
    if (drawer.hasAttribute('open')) return;
    // Capture scroll BEFORE the dialog opens. showModal() can shift focus
    // and trigger the browser's auto-scroll-into-view, moving the page
    // before we'd otherwise measure it. lockBodyScroll uses this override
    // so the lockedY reflects the customer's true pre-open position.
    var preOpenScrollY = window.scrollY || window.pageYOffset || 0;
    if (typeof drawer.showModal === 'function') {
      try { drawer.showModal(); } catch (e) { drawer.setAttribute('open', 'true'); }
    } else {
      drawer.setAttribute('open', 'true');
    }
    lockBodyScroll(preOpenScrollY);

    // Defensive: sweep orphan personalización lines on every drawer open.
    // If any were purged, re-render the drawer + badge so the customer
    // sees the corrected cart immediately (otherwise the stale orphan
    // rows would remain visible until the next interaction).
    enqueue(function () {
      return getCart().then(function (cart) {
        if (cart && cart.__sweptOrphans) {
          refreshDrawerFromServer();
          updateCartCount();
        }
      });
    }).catch(function () {});

    drawer.addEventListener('click', function onBackdrop(ev) {
      if (ev.target === drawer) {
        closeDrawer();
        drawer.removeEventListener('click', onBackdrop);
      }
    });

    drawer.addEventListener('close', function onClose() {
      unlockBodyScroll();
      drawer.removeEventListener('close', onClose);
    });
  }

  function closeDrawer() {
    var drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) return;
    if (typeof drawer.close === 'function') {
      drawer.close();
    } else {
      drawer.removeAttribute('open');
    }
    unlockBodyScroll();
  }

  function wireProductForms() {
    // Document-level delegation so it survives drawer re-renders (replaceDrawer)
    // and catches both the PDP product form ([data-product-form]) and the
    // in-drawer "Completa tu pedido" upsell forms ([data-cart-rec]).
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form || !form.matches) return;
      if (form.matches('[data-product-form]') || form.matches('[data-cart-rec]')) {
        onProductSubmit(ev);
      }
    });
  }

  // True when the form / event originated inside the full cart page section
  // (sections/cart.liquid). On the cart page we don't want to open the drawer
  // when a "Completa tu pedido" rec is added — we want to reload the page so
  // the cart line items + summary update naturally.
  function isInCartPage(node) {
    return !!(node && node.closest && node.closest('[data-cart-section]'));
  }

  function onProductSubmit(ev) {
    var form = ev.target;
    ev.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.setAttribute('disabled', '');
    var originalText = submitBtn ? submitBtn.innerHTML : '';

    var fromCartPage = isInCartPage(form);

    // Detect bundle: only a "Sets Esenciales" product form carries the
    // [data-bundle-picker] element. Its `_selected` Set (populated by the
    // picker JS in sections/product.liquid) holds the chosen product handles.
    var bundleWrap = form.querySelector('[data-bundle-picker]');
    var bundleOn = !!(bundleWrap && bundleWrap._selected && bundleWrap._selected.size > 0);

    // Detect personalización: ONLY the PDP product form carries the
    // [data-personalization] block; in-drawer recs ([data-cart-rec]) never do.
    //
    // Trigger condition: the engraving input has a non-empty sanitized value.
    // The input starts disabled in the markup and only becomes enabled when
    // the customer clicks the "Añadir personalización" radio (applyMode in
    // product-controller.js). Disabled inputs are not submitted by the
    // browser, so if `properties[Iniciales]` arrives with a non-empty value
    // at this point, the customer DID enable + type into the field. Relying
    // on iniciales alone (rather than addRadio.checked) eliminates a real
    // bug class observed 2026-05-26: customers checking out with only the
    // main line + "Iniciales: AM" property and no $49 perso line. addRadio
    // could desync from form state via JS-set checked, DOM manipulation,
    // or radio-group race; the form submission state is authoritative.
    var persoWrap = form.querySelector('[data-personalization]');
    var addRadio = persoWrap
      ? persoWrap.querySelector('[data-personalization-radio][data-personalization-mode="add"]')
      : null;
    var inicialesInput = form.querySelector('input[name="properties[Iniciales]"]');
    var iniciales = inicialesInput ? sanitizePers(inicialesInput.value) : '';
    var personalizationOn = !!(persoWrap && iniciales);

    // Multi-piece personalización (legacy bundles, e.g. minimalbundle): the
    // PDP renders one checkbox + initials field per pieza (property keys
    // 'Iniciales <Pieza>', trailing space) and NO plain properties[Iniciales]
    // input, so `iniciales` above is always '' for these forms. pieces[]
    // collects the sanitized per-piece pairs from the live DOM; the FormData
    // copy in the perso branch below is overwritten with these sanitized
    // values. Same trust-the-form principle as the single field: piece
    // fields start disabled and only enable via their checkbox, which itself
    // only enables with the "Agrega Iniciales" radio.
    var pieceChecks = form.querySelectorAll('[data-perso-piece-check]');
    var persoMulti = pieceChecks.length > 0;
    var pieces = [];
    var emptyPieceField = null;
    var checkedPieceEmpty = false;
    if (persoMulti) {
      pieceChecks.forEach(function (check) {
        if (!check.checked) return;
        var pieceRow = check.closest('[data-perso-piece]');
        var pieceField = pieceRow ? pieceRow.querySelector('[data-perso-piece-field]') : null;
        var pieceLabel = pieceField ? (pieceField.dataset.persoPieceLabel || '') : '';
        var pieceVal = pieceField ? sanitizePers(pieceField.value) : '';
        if (pieceLabel && pieceVal) {
          pieces.push({ key: 'Iniciales ' + pieceLabel, value: pieceVal });
        } else {
          checkedPieceEmpty = true;
          if (!emptyPieceField && pieceField) emptyPieceField = pieceField;
        }
      });
      personalizationOn = pieces.length > 0;
    }

    // Guard (multi-piece): "Agrega Iniciales" selected but no pieza is
    // checked, or a checked pieza's field is empty. Blocking prompt, same
    // rationale as the single-field guard below.
    if (!bundleOn && persoMulti && persoWrap && addRadio && addRadio.checked && (pieces.length === 0 || checkedPieceEmpty)) {
      var persoPiecesErr = persoWrap.querySelector('[data-personalization-error]');
      if (persoPiecesErr) {
        persoPiecesErr.textContent = "Selecciona al menos una pieza y agrega sus iniciales, o elige 'Sin iniciales' para continuar.";
        persoPiecesErr.hidden = false;
      }
      if (submitBtn) { submitBtn.removeAttribute('disabled'); submitBtn.innerHTML = originalText; }
      var focusPieceTarget = emptyPieceField || pieceChecks[0];
      if (focusPieceTarget) { try { focusPieceTarget.focus(); } catch (e) {} }
      return;
    }

    // Guard: the customer selected "Agrega Iniciales" but left the engraving
    // field empty. Block the add and prompt them to type initials OR pick
    // "Sin iniciales", instead of silently adding a non-personalized order.
    // (This intentionally reads addRadio.checked — it is a blocking prompt, not
    // an add-decision, so a desynced radio at worst shows a harmless prompt the
    // user clears by typing or choosing "Sin iniciales".) Adolfo flagged 2026-06-08.
    if (!bundleOn && !persoMulti && persoWrap && addRadio && addRadio.checked && !iniciales) {
      var persoEmptyErr = persoWrap.querySelector('[data-personalization-error]');
      if (persoEmptyErr) {
        persoEmptyErr.textContent = "Agrega tus iniciales o elige 'Sin iniciales' para continuar.";
        persoEmptyErr.hidden = false;
      }
      if (submitBtn) { submitBtn.removeAttribute('disabled'); submitBtn.innerHTML = originalText; }
      if (inicialesInput) { try { inicialesInput.focus(); } catch (e) {} }
      return;
    }

    // Guard (Certificado de Autenticidad): required owner-name fields must
    // be filled before ANY add path (plain, perso, multi) proceeds.
    var certEmptyField = validateCertificate(form);
    if (certEmptyField) {
      if (submitBtn) { submitBtn.removeAttribute('disabled'); submitBtn.innerHTML = originalText; }
      try { certEmptyField.focus(); } catch (e) {}
      return;
    }

    var fetchOpts;

    if (bundleOn) {
      console.info('[bundle-v2] add: building atomic N+M payload from picker selections');
      // Build-your-own-bundle v2: ONE atomic /cart/add.js with N main items
      // (each carrying the visible `Set` property) PLUS M perso `custom`
      // items (one per personalized pick) paired via `_perso_id` so the
      // existing cart-drawer linkage finds the pair. The host Sets product
      // itself is NOT added - it is only the picker shell.
      // /cart/add.js with multiple `items` is atomic: one sold-out pick or
      // one over-quantity variant fails the whole add.
      var setTitle = bundleWrap.dataset.bundleSetTitle || '';
      var bundleItems = [];
      var persoItems = [];
      var seenMainVariants = {};

      // Re-validate at submit time: if any SELECTED tile is incomplete
      // (multi-variant with no chosen variant in the picker Map) we must NOT
      // silently drop it (or worse: fall back to its Liquid-rendered first
      // variant attr and add the WRONG color/size). The picker disables ATC
      // in this state, but a desync (rapid toggle, JS race) could let a submit
      // through. A tile is incomplete when aria-pressed=true AND its
      // data-bundle-variants JSON has >1 variant AND the Map has no resolved
      // variantId. Mirrors product-controller.js tileIsIncomplete().
      var hasIncompletePick = false;
      var selectedTiles = bundleWrap.querySelectorAll('[data-bundle-tile]');
      for (var bi = 0; bi < selectedTiles.length; bi++) {
        var t0 = selectedTiles[bi];
        if (t0.getAttribute('aria-pressed') !== 'true') continue;
        var t0variants = [];
        try { t0variants = JSON.parse(t0.dataset.bundleVariants || '[]'); } catch (e) { t0variants = []; }
        if (t0variants.length <= 1) continue; // single-variant tile auto-resolves
        var t0state = (bundleWrap._selected && bundleWrap._selected.get)
          ? bundleWrap._selected.get(t0.dataset.bundleHandle || '')
          : null;
        if (!t0state || !t0state.variantId) { hasIncompletePick = true; break; }
      }
      if (hasIncompletePick) {
        if (submitBtn) {
          submitBtn.removeAttribute('disabled');
          submitBtn.innerHTML = originalText;
        }
        alert('Una de tus piezas necesita color o talla. Elige una opción antes de continuar.');
        return;
      }

      // Read the picker's Map<handle, {variantId, personalization}>.
      // We iterate tiles in DOM order so the cart preserves the visual
      // order of the picker (UX nicety, not functional).
      bundleWrap.querySelectorAll('[data-bundle-tile]').forEach(function (tile) {
        if (tile.getAttribute('aria-pressed') !== 'true') return;
        var handle = tile.dataset.bundleHandle || '';
        if (!handle) return;
        var state = bundleWrap._selected && bundleWrap._selected.get
          ? bundleWrap._selected.get(handle)
          : null;
        // variantId can come from the Map (chooser-picked) or fall back to
        // the data attr (single-variant fast path, v1 behavior).
        var variantId = (state && state.variantId)
          ? String(state.variantId)
          : (tile.dataset.bundleVariantId ? String(tile.dataset.bundleVariantId) : '');
        if (!variantId) return; // incomplete pick - picker should have blocked
        if (seenMainVariants[variantId]) return; // dedupe (same variant twice)
        seenMainVariants[variantId] = true;

        var mainProps = { Set: setTitle };
        if (state && state.personalization && state.personalization.initials) {
          mainProps._perso_id = state.personalization.persoId;
          mainProps.Iniciales = state.personalization.initials;
          // Paired perso `custom` line: $49 MXN, links via _perso_id.
          persoItems.push({
            id: String(PERSO_VARIANT_ID),
            quantity: 1,
            properties: {
              _perso_id: state.personalization.persoId,
              Para: tile.dataset.bundleName || '',
              Iniciales: state.personalization.initials
            }
          });
        }
        bundleItems.push({
          id: variantId,
          quantity: 1,
          properties: mainProps
        });
      });

      // Defensive: if every selected tile resolved to no variant id (every
      // pick was incomplete), abort cleanly. The picker disables ATC in
      // this case, but defense in depth.
      if (!bundleItems.length) {
        if (submitBtn) {
          submitBtn.removeAttribute('disabled');
          submitBtn.innerHTML = originalText;
        }
        alert('Selecciona al menos una pieza completa para tu bundle.');
        return;
      }

      // Guard (bundle): "Agrega Iniciales" selected but NO pick was
      // personalized. The bundle branch builds a $49 perso line ONLY for
      // picks carrying initials, so persoItems.length === 0 means the
      // customer asked to add initials yet completed none. The 2pc/standard
      // guards above are gated !bundleOn and skip this branch, so block here.
      if (addRadio && addRadio.checked && persoItems.length === 0) {
        if (submitBtn) { submitBtn.removeAttribute('disabled'); submitBtn.innerHTML = originalText; }
        var bundlePersoErr = persoWrap.querySelector('[data-personalization-error]');
        if (bundlePersoErr) {
          bundlePersoErr.textContent = "Selecciona al menos una pieza y agrega sus iniciales, o elige 'Sin iniciales' para continuar.";
          bundlePersoErr.hidden = false;
        }
        var firstBundleCheck = bundleWrap.querySelector('[data-bundle-perso-check]');
        if (firstBundleCheck) { try { firstBundleCheck.focus(); } catch (e) {} }
        return;
      }

      // Main items first, then paired perso items. Shopify processes the
      // array in order; pairing is by `_perso_id` property, not adjacency.
      var allBundleItems = bundleItems.concat(persoItems);

      fetchOpts = {
        method: 'POST',
        body: JSON.stringify({ items: allBundleItems, sections: SECTION_ID }),
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' }
      };
    } else if (personalizationOn) {
      // Two linked line items in ONE atomic /cart/add.js call.
      var fd = new FormData(form);
      var mainId = fd.get('id');
      var rawQty = parseInt(fd.get('quantity'), 10);
      var qty = (isNaN(rawQty) || rawQty < 1) ? 1 : rawQty;
      var persoId = makePersoId();
      var productTitle = (persoWrap && persoWrap.dataset.personalizationProductTitle) || '';

      // Main line: every non-empty property already on the form, plus the
      // hidden _perso_id link. `Iniciales` is already in the form properties.
      var mainProps = { _perso_id: persoId };
      fd.forEach(function (val, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && val !== null && val !== undefined && val !== '') {
          mainProps[m[1]] = val;
        }
      });

      var items;
      if (persoMulti) {
        // Multi-piece: NO plain Iniciales key on either line. The fd forEach
        // above already copied the per-piece inputs (raw values); overwrite
        // each with its sanitized value (belt-and-braces — the input handler
        // sanitizes live, but a paste-then-submit race could slip an
        // unsanitized value into the FormData snapshot).
        var multiPersoProps = { _perso_id: persoId, Para: productTitle };
        pieces.forEach(function (p) {
          mainProps[p.key] = p.value;
          multiPersoProps[p.key] = p.value;
        });
        items = [
          { id: mainId, quantity: qty, properties: mainProps },
          {
            id: String(PERSO_VARIANT_ID),
            // One $49 fee per engraved pieza: qty = piezas x main qty.
            quantity: qty * pieces.length,
            properties: multiPersoProps
          }
        ];
      } else {
        mainProps.Iniciales = iniciales;

        items = [
          { id: mainId, quantity: qty, properties: mainProps },
          {
            id: String(PERSO_VARIANT_ID),
            quantity: qty,
            properties: {
              _perso_id: persoId,
              Para: productTitle,
              Iniciales: iniciales
            }
          }
        ];
      }

      fetchOpts = {
        method: 'POST',
        body: JSON.stringify({ items: items, sections: SECTION_ID }),
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' }
      };
    } else {
      // No personalización: single-item multipart add. Strip empty properties
      // first so an enabled-but-empty Iniciales does not post
      // properties[Iniciales]='' (Shopify keeps empty keys). Strip BEFORE
      // appending `sections` so that control key is never removed.
      var formData = new FormData(form);
      stripEmptyFormDataProps(formData);
      formData.append('sections', SECTION_ID);
      fetchOpts = {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/javascript' }
      };
    }

    fetch('/cart/add.js', fetchOpts)
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (data) {
        // Cart page: reload so the line items + subtotal + free-shipping bar
        // refresh. The drawer doesn't need to open since the cart UI is
        // already the user's primary view.
        if (fromCartPage) {
          window.location.reload();
          return;
        }
        if (data.sections && data.sections[SECTION_ID]) {
          replaceDrawer(data.sections[SECTION_ID]);
          notifyCartUpdated();
        }
        updateCartCount();
        openDrawer();
      })
      .catch(function (err) {
        var msg = (err && err.description) || (err && err.message) || 'No se pudo agregar el producto.';
        alert(msg);
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.removeAttribute('disabled');
          submitBtn.innerHTML = originalText;
        }
      });
  }

  function wireLineChanges() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-cart-change]');
      if (!btn) return;
      var action = btn.dataset.cartChange;
      var key = btn.dataset.lineKey;
      if (!key) return;

      var currentLine = findLine(key);
      var quantity = 1;
      if (currentLine) {
        var valueEl = currentLine.querySelector('[data-qty-value]');
        var current = valueEl ? parseInt(valueEl.textContent, 10) : 1;
        if (action === 'increment') quantity = current + 1;
        else if (action === 'decrement') quantity = Math.max(0, current - 1);
        else if (action === 'remove') quantity = 0;
      }

      // For remove, play the exit animation BEFORE swapping the drawer DOM
      // so the row visibly slides out instead of popping.
      if (action === 'remove' && currentLine) {
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var delay = reduce ? 0 : 280;
        // Lock the current height so max-height transition has a real starting value.
        currentLine.style.maxHeight = currentLine.offsetHeight + 'px';
        // Force a reflow so the locked height takes effect before adding the class.
        // eslint-disable-next-line no-unused-expressions
        currentLine.offsetHeight;
        currentLine.classList.add('is-removing');
        setTimeout(function () { changeLine(key, 0); }, delay);
        return;
      }

      changeLine(key, quantity);
    });
  }

  function findLine(key) {
    return document.querySelector('[data-cart-line="' + key + '"]');
  }

  // changeLine applies a qty change to one cart line. If that line is a
  // personalized MAIN product (carries _perso_id), its linked $49
  // personalización line is changed to the SAME quantity (qty 0 removes
  // it). All requests are serialized through enqueue() to avoid 429s.
  function changeLine(key, quantity) {
    enqueue(function () {
      return getCart().then(function (cart) {
        var thisItem = (cart.items || []).filter(function (it) { return it.key === key; })[0];
        var persoId = persoIdOf(thisItem);
        var isPersoLineItself = thisItem && thisItem.handle === PERSO_HANDLE;
        var persoLine = (persoId && !isPersoLineItself)
          ? findPersoLine(cart, persoId)
          : undefined;

        // 1) apply the requested change to the main/target line first,
        //    asking for the rendered section back on THIS call. On the
        //    no-partner path that response is the final state — there is
        //    no second call. (Re-POSTing { id: key } after a qty-0 remove
        //    would target a line key that no longer exists -> non-2xx ->
        //    the removed row would stay visible. Spec 2026-05-20 / BL-2.)
        return changeRequest({ id: key, quantity: quantity, sections: SECTION_ID }).then(function (firstData) {
          // 2) mirror to the linked personalización line if there is one.
          //    quantity 0 on the main line removes the $49 line too. This
          //    second response (also section-rendered) is what the drawer
          //    swaps in. No partner -> return the step-1 response.
          if (persoLine) {
            // Multi-piece mains mirror at piezas x qty (persoFactorOf is 1
            // for single engravings, and qty 0 still removes the line).
            return changeRequest({
              id: persoLine.key,
              quantity: quantity * persoFactorOf(thisItem),
              sections: SECTION_ID
            });
          }
          return firstData;
        });
      });
    })
      .then(function (data) {
        if (data && data.sections && data.sections[SECTION_ID]) {
          replaceDrawer(data.sections[SECTION_ID]);
          notifyCartUpdated();
        }
        // /cart/change.js returns the full cart; compute the visible
        // count (custom lines excluded) so the badge matches the
        // Liquid-rendered drawer header from this same response.
        if (data && data.items) {
          updateCartCount(visibleCartCount(data.items));
        } else {
          updateCartCount();
        }
      })
      .catch(function (err) {
        // A multi-step changeLine can leave the cart in a state the
        // stale drawer DOM no longer reflects (e.g. the main line was
        // removed but mirroring the $49 line failed). Re-sync the drawer
        // to true server state from a freshly rendered section, refresh
        // the badge, and tell the customer. Spec 2026-05-20 / BL-3(b).
        console.error('[cart-drawer] change error', err);
        refreshDrawerFromServer();
        updateCartCount();
        alert((err && err.description) || 'No se pudo actualizar la bolsa. La actualizamos con el estado más reciente.');
      });
  }

  // Re-fetch the cart drawer section markup from Shopify's Section
  // Rendering API (a GET — does NOT mutate the cart) and swap it into the
  // drawer, so the drawer reflects true server state after a failed
  // multi-step operation. Spec 2026-05-20 / BL-3(b).
  function refreshDrawerFromServer() {
    return fetch('/?sections=' + SECTION_ID, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data[SECTION_ID]) {
          replaceDrawer(data[SECTION_ID]);
          notifyCartUpdated();
        }
      })
      .catch(function (e) { console.error('[cart-drawer] drawer refresh failed', e); });
  }

  function replaceDrawer(html) {
    var drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) return;
    var wasOpen = drawer.hasAttribute('open');

    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newDrawer = doc.querySelector(DRAWER_SELECTOR);
    if (!newDrawer) {
      var newInner = doc.querySelector('.cart-drawer__inner');
      if (!newInner) return;
      var currentInner = drawer.querySelector('.cart-drawer__inner');
      if (currentInner) currentInner.replaceWith(newInner);
      return;
    }

    var newInnerNode = newDrawer.querySelector('.cart-drawer__inner');
    var currentInnerNode = drawer.querySelector('.cart-drawer__inner');
    if (newInnerNode && currentInnerNode) {
      currentInnerNode.replaceWith(newInnerNode);
    }

    if (wasOpen && !drawer.hasAttribute('open')) {
      drawer.setAttribute('open', 'true');
    }
  }

  // Notify the gift-cart engine that the cart changed and the drawer
  // section was re-rendered server-side.
  function notifyCartUpdated() {
    document.dispatchEvent(new CustomEvent('le:cart:updated'));
  }

  // After the gift engine adds/removes a gift line, re-render the drawer
  // so the new line item + subtotal show. Reuses refreshDrawerFromServer.
  function wireGiftRefresh() {
    document.addEventListener('le:gift:added', function () {
      refreshDrawerFromServer().then(function () {
        updateCartCount();
        // notifyCartUpdated() not needed here -- refreshDrawerFromServer
        // already dispatches le:cart:updated internally on success.
      });
    });
  }

  // Sum quantity over all cart lines EXCEPT personalización lines
  // (product handle `custom`). This is the "visible count" — it must
  // match the server-rendered Liquid header/badge counts, which also
  // exclude `custom` lines. Using Shopify's raw cart.item_count here
  // would over-count: one personalized product would flash "2".
  function visibleCartCount(items) {
    if (!items || !items.length) return 0;
    return items.reduce(function (sum, it) {
      return it.handle === PERSO_HANDLE ? sum : sum + (it.quantity || 0);
    }, 0);
  }

  // updateCartCount refreshes the header cart badge. Called with no
  // argument it re-fetches /cart.js and computes the visible count
  // (personalización `custom` lines excluded) so the JS-updated badge
  // always agrees with the Liquid-rendered one — no flicker to the
  // raw cart.item_count. The numeric `count` form is the render path.
  function updateCartCount(count) {
    if (count === undefined) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (data) { updateCartCount(visibleCartCount(data.items)); })
        .catch(function () {});
      return;
    }

    var badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach(function (b) {
      b.textContent = count;
      b.style.display = count > 0 ? '' : 'none';
    });

    var cartButtons = document.querySelectorAll('.site-header__action--cart');
    cartButtons.forEach(function (btn) {
      var existingBadge = btn.querySelector('[data-cart-count]');
      if (count > 0 && !existingBadge) {
        var span = document.createElement('span');
        span.className = 'site-header__count';
        span.setAttribute('data-cart-count', '');
        span.textContent = count;
        btn.appendChild(span);
      } else if (count === 0 && existingBadge) {
        existingBadge.remove();
      }
    });
  }

  // Remove any empty-valued line-item property (e.g. an enabled-but-empty
  // Iniciales engraving input) from a multipart cart add. Shopify keeps
  // empty-string properties once posted, so a customer who enables
  // "Agrega Iniciales" then adds without typing would otherwise leave an
  // empty `Iniciales:` key on the order. The personalización branch already
  // filters empties (val !== ''); this mirrors that for the raw FormData add.
  function stripEmptyFormDataProps(fd) {
    var emptyKeys = [];
    fd.forEach(function (val, key) {
      if (/^properties\[.+\]$/.test(key) && (val == null || String(val).trim() === '')) {
        emptyKeys.push(key);
      }
    });
    emptyKeys.forEach(function (k) { fd.delete(k); });
    return fd;
  }

  // Sanitize personalization input: NFD-deaccent + strip non-[A-Z0-9].
  function sanitizePers(raw) {
    if (!raw) return '';
    var deaccented = raw.normalize ? raw.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : raw;
    return deaccented.toUpperCase().replace(/[^A-Z0-9]/g, '');
  }
  // Expose for product-controller.js (bundle picker per-tile perso input).
  window.sanitizePers = sanitizePers;

  function tooManyRepeats(value) {
    return value && /(.)\1{3,}/.test(value);
  }
  window.tooManyRepeats = tooManyRepeats;

  // Certificado de Autenticidad guard (Pliego): the [data-certificate]
  // module's fields are required before any add path proceeds. Whitespace
  // is normalized in-place (the trimmed value is what FormData posts) but
  // names are NEVER run through sanitizePers — accents and ñ are valid.
  // Returns the first empty input (caller focuses it) or null when valid.
  function validateCertificate(form) {
    var cert = form.querySelector('[data-certificate]');
    if (!cert) return null;
    var firstEmpty = null;
    cert.querySelectorAll('[data-certificate-input]').forEach(function (inp) {
      inp.value = inp.value.replace(/\s+/g, ' ').trim();
      inp.classList.toggle('is-invalid', !inp.value);
      if (!inp.value && !firstEmpty) firstEmpty = inp;
    });
    var certErr = cert.querySelector('[data-certificate-error]');
    if (firstEmpty) {
      if (certErr) {
        certErr.textContent = 'Completa el nombre y apellido para tu Certificado de Autenticidad.';
        certErr.hidden = false;
      }
      return firstEmpty;
    }
    if (certErr) { certErr.hidden = true; certErr.textContent = ''; }
    return null;
  }
  // Expose for product-controller.js (Buy Now path shares the same guard).
  window.validateCertificate = validateCertificate;

  // Native constraint validation (the inputs are `required`) blocks the form
  // submit BEFORE onProductSubmit runs, so the themed error would never show
  // on the ATC path. 'invalid' fires per-field when that happens — mirror the
  // themed styling alongside the browser bubble. Capture phase: 'invalid'
  // does not bubble.
  document.addEventListener('invalid', function (ev) {
    var certInput = ev.target && ev.target.closest ? ev.target.closest('[data-certificate-input]') : null;
    if (!certInput) return;
    certInput.classList.add('is-invalid');
    var certWrap = certInput.closest('[data-certificate]');
    var certErr = certWrap ? certWrap.querySelector('[data-certificate-error]') : null;
    if (certErr) {
      certErr.textContent = 'Completa el nombre y apellido para tu Certificado de Autenticidad.';
      certErr.hidden = false;
    }
  }, true);

  // Live recovery: typing into a certificate field clears its invalid state
  // and hides the error once both fields have content.
  document.addEventListener('input', function (ev) {
    var certInput = ev.target.closest('[data-certificate-input]');
    if (!certInput) return;
    if (certInput.value.trim()) certInput.classList.remove('is-invalid');
    var certWrap = certInput.closest('[data-certificate]');
    if (!certWrap) return;
    var anyEmpty = false;
    certWrap.querySelectorAll('[data-certificate-input]').forEach(function (inp) {
      if (!inp.value.trim()) anyEmpty = true;
    });
    if (!anyEmpty) {
      var certErr = certWrap.querySelector('[data-certificate-error]');
      if (certErr) { certErr.hidden = true; certErr.textContent = ''; }
    }
  });

  // Unique id linking a main product line to its personalización line.
  function makePersoId() {
    return 'p_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
  }
  window.makePersoId = makePersoId;

  // Read the live cart. Resolves to the parsed cart object AFTER any
  // orphan personalización lines have been swept (see
  // cleanOrphanPersoLines). Every code path that reads the cart goes
  // through here, so the sweep happens before any subsequent mutation
  // makes a decision against stale data.
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return cleanOrphanPersoLines(cart); });
  }

  // Defensive sweep: removes any $49 personalización line whose
  // `_perso_id` does not link back to a non-perso (main) line in the
  // cart. Orphans are produced when the cascade-on-removal step fails
  // (the main line was removed but mirroring qty=0 onto the linked perso
  // line errored), when a perso add succeeds but the follow-up that sets
  // `_perso_id` on the main line silently dropped, and when CASE B
  // updates race with a re-add. Left in place, every orphan is a silent
  // $49 overcharge at checkout because the cart total still sums them
  // even if the drawer hides them. LE1030 incident 2026-05-25: 5 perso
  // lines billed where 2 were intended -> $147 customer overcharge.
  //
  // Returns the cart unchanged when nothing was orphaned. When orphans
  // were purged, returns a refreshed cart object with `__sweptOrphans`
  // (count) attached so callers can refresh the visible drawer / cart
  // section if needed. Direct /cart.js re-read (not getCart) to avoid
  // recursion.
  function cleanOrphanPersoLines(cart) {
    if (!cart || !cart.items || !cart.items.length) return cart;

    // Build the set of `_perso_id` values present on every non-perso
    // (main) line.
    var mainPersoIds = {};
    cart.items.forEach(function (it) {
      if (it.handle !== PERSO_HANDLE && it.properties && it.properties._perso_id) {
        mainPersoIds[it.properties._perso_id] = true;
      }
    });

    // A perso line is valid iff it carries a `_perso_id` that matches a
    // main line AND it is the first perso line we have seen for that
    // id (the contract is one perso line per main, with qty mirroring).
    // Anything else is an orphan.
    var seenIds = {};
    var orphans = cart.items.filter(function (it) {
      if (it.handle !== PERSO_HANDLE) return false;
      var pid = it.properties && it.properties._perso_id;
      if (!pid) return true;                  // no link at all
      if (!mainPersoIds[pid]) return true;    // link points to nothing
      if (seenIds[pid]) return true;          // duplicate for same main
      seenIds[pid] = true;
      return false;
    });

    if (!orphans.length) return cart;

    console.warn('[cart-drawer] sweeping ' + orphans.length +
      ' orphan personalización line(s)');

    // Remove each orphan in sequence so a /cart/* 429 burst is avoided.
    // Per-line failures are logged but do not block subsequent removals
    // -- the next cart read will retry the sweep. Track the number that
    // actually succeeded so a permanently-failing line (line key vanished
    // mid-request, server-side lock) does not trigger a refresh storm on
    // every interaction.
    var removed = 0;
    var p = Promise.resolve();
    orphans.forEach(function (orphan) {
      p = p.then(function () {
        return changeRequest({ id: orphan.key, quantity: 0 })
          .then(function () { removed++; })
          .catch(function (e) {
            console.error('[cart-drawer] orphan sweep failed for line ' +
              orphan.key, e);
          });
      });
    });

    // Re-read /cart.js so callers downstream of getCart() see the
    // post-sweep state. Direct fetch (not getCart) to avoid recursion.
    // If zero removals succeeded, skip the re-read and return the
    // original cart unchanged -- nothing on the server actually changed.
    return p.then(function () {
      if (!removed) return cart;
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (freshCart) {
          if (freshCart) freshCart.__sweptOrphans = removed;
          return freshCart;
        });
    });
  }

  // Given a cart object and a _perso_id, return the personalización line
  // item (handle `custom`) carrying that id, or undefined.
  function findPersoLine(cart, persoId) {
    if (!cart || !cart.items || !persoId) return undefined;
    return cart.items.filter(function (it) {
      return it.handle === PERSO_HANDLE
        && it.properties
        && it.properties._perso_id === persoId;
    })[0];
  }

  // Given a cart object and a main line item, return its _perso_id or ''.
  function persoIdOf(item) {
    return (item && item.properties && item.properties._perso_id) || '';
  }

  // Number of engraved piezas a personalized MAIN line carries: counts
  // property keys with the 'Iniciales ' prefix (trailing space — the
  // multi-piece bundle keys, e.g. 'Iniciales Billetera'). Single-engraving
  // lines (plain `Iniciales`, no trailing space) have none of those keys
  // and factor as 1, so persoQty = mainQty * persoFactorOf(mainItem) holds
  // for every personalized line, single or multi.
  function persoFactorOf(item) {
    var n = 0;
    if (item && item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        if (k.indexOf('Iniciales ') === 0) n++;
      });
    }
    return n > 0 ? n : 1;
  }

  // Remove a personalized main line + its $49 line, then RE-ADD the main line
  // WITHOUT the perso properties (preserving variant, qty, and any non-perso
  // properties). Shopify KEEPS empty-string line-item properties: setting
  // Iniciales/_perso_id to '' leaves visible empty keys on the order that the
  // fulfillment team reads as "is this an error?", and the cart API cannot
  // delete a property key once it exists -- so a clean re-add is the only way to
  // leave the line with NO perso keys at all. Used by the perso remove (X) and
  // the edit "save with empty value" (CASE A). Returns the section-rendered
  // addRequest response. Adolfo flagged 2026-06-08.
  function rebuildLineWithoutPerso(mainItem, persoLine) {
    var qty = mainItem.quantity || 1;
    var cleanProps = {};
    if (mainItem.properties) {
      Object.keys(mainItem.properties).forEach(function (k) {
        if (k === 'Iniciales' || k === '_perso_id' || k.indexOf('Iniciales ') === 0) return;
        var val = mainItem.properties[k];
        if (val !== null && val !== undefined && val !== '') cleanProps[k] = val;
      });
    }
    return changeRequest({ id: mainItem.key, quantity: 0 })
      .then(function () {
        if (persoLine) return changeRequest({ id: persoLine.key, quantity: 0 });
      })
      .then(function () {
        return addRequest([
          { id: mainItem.variant_id, quantity: qty, properties: cleanProps }
        ], true);
      });
  }

  // Serialize cart-mutating requests. Shopify's /cart/* endpoints 429 under
  // concurrent writes; chaining them on one promise tail prevents races
  // (spec 2026-05-20: "debounced to avoid races").
  var cartQueue = Promise.resolve();
  function enqueue(taskFn) {
    var run = cartQueue.then(function () { return taskFn(); });
    // Keep the chain alive even if a task rejects.
    cartQueue = run.catch(function () {});
    return run;
  }

  // Bounded retry around a fetch() for transient cart-endpoint failures.
  // Shopify's /cart/* endpoints return 429 (rate limit) under burst writes
  // and occasionally 5xx — both documented LE/AO production failure modes.
  // Retries up to MAX_CART_RETRIES times with a ~600ms backoff ONLY on
  // 429 / 5xx. A 4xx other than 429 (e.g. 422 sold-out) is a real error
  // and resolves immediately so the caller can surface it. Network
  // rejections also retry — a dropped connection is transient too.
  // Spec 2026-05-20 / BL-3(a).
  var MAX_CART_RETRIES = 2;
  var CART_RETRY_DELAY = 600;
  function fetchWithRetry(url, opts, attempt) {
    attempt = attempt || 0;
    return fetch(url, opts).then(function (r) {
      var retriable = r.status === 429 || (r.status >= 500 && r.status <= 599);
      if (retriable && attempt < MAX_CART_RETRIES) {
        return delay(CART_RETRY_DELAY).then(function () {
          return fetchWithRetry(url, opts, attempt + 1);
        });
      }
      return r;
    }, function (networkErr) {
      if (attempt < MAX_CART_RETRIES) {
        return delay(CART_RETRY_DELAY).then(function () {
          return fetchWithRetry(url, opts, attempt + 1);
        });
      }
      throw networkErr;
    });
  }

  function delay(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  // POST /cart/change.js, resolve to parsed JSON. Used inside enqueue().
  // Routed through fetchWithRetry so a transient 429/5xx is retried
  // before the failure propagates.
  function changeRequest(payload) {
    return fetchWithRetry('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  // POST /cart/add.js with an items[] array, resolve to parsed JSON.
  // Routed through fetchWithRetry for the same transient-failure handling.
  function addRequest(items, withSections) {
    var body = { items: items };
    if (withSections) body.sections = SECTION_ID;
    return fetchWithRetry('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(body),
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' }
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function wirePersonalizationEdit() {
    // Two-tap confirm state for the personalización remove X. Scoped here so it
    // persists across every delegated click on the single document listener.
    var armedRemoveBtn = null;
    var armedRemoveTimer = null;
    function disarmPersoRemove() {
      if (armedRemoveTimer) clearTimeout(armedRemoveTimer);
      if (armedRemoveBtn) {
        armedRemoveBtn.classList.remove('is-confirming');
        armedRemoveBtn.setAttribute('aria-label', 'Quitar personalización');
        armedRemoveBtn.setAttribute('title', 'Quitar personalización');
      }
      armedRemoveBtn = null;
      armedRemoveTimer = null;
    }

    document.addEventListener('click', function (ev) {
      // X button to remove personalization from a line item.
      // Removes the linked $49 personalización line, then clears Iniciales
      // + _perso_id from the main line.
      var removeBtn = ev.target.closest('[data-cart-pers-remove]');
      if (removeBtn) {
        ev.preventDefault();
        var key = removeBtn.dataset.lineKey;
        if (!key) return;
        // Guard against accidental taps: the X sits next to the qty controls and
        // is easy to mis-tap on mobile, and an accidental removal silently drops
        // the customer's engraving -> they receive an unpersonalized order and
        // complain. Adolfo flagged 2026-06-08. We use an inline TWO-TAP confirm
        // (first tap arms the X and shows a "¿Quitar?" label, second tap within
        // 3s removes; auto-resets otherwise) instead of window.confirm() because
        // native confirm() is sandboxed/blocked inside the Shopify Theme Editor
        // "Customize" preview iframe (no allow-modals) and returns falsy, which
        // made the X appear dead on the SKELETON preview.
        if (removeBtn !== armedRemoveBtn) {
          // FIRST tap: clear any other armed button, then arm this one.
          disarmPersoRemove();
          armedRemoveBtn = removeBtn;
          removeBtn.classList.add('is-confirming');
          removeBtn.setAttribute('aria-label', 'Toca de nuevo para quitar');
          removeBtn.setAttribute('title', 'Toca de nuevo para quitar');
          armedRemoveTimer = setTimeout(disarmPersoRemove, 3000);
          return;
        }
        // SECOND tap (already armed): clear armed state and fall through to the
        // existing removal flow below.
        clearTimeout(armedRemoveTimer);
        armedRemoveTimer = null;
        armedRemoveBtn = null;
        removeBtn.classList.remove('is-confirming');
        var fromCartPageRm = isInCartPage(removeBtn);
        removeBtn.setAttribute('disabled', '');
        enqueue(function () {
          return getCart().then(function (cart) {
            var mainItem = (cart.items || []).filter(function (it) { return it.key === key; })[0];
            if (!mainItem) throw new Error('line not found');
            var persoId = persoIdOf(mainItem);
            var persoLine = findPersoLine(cart, persoId);
            // Re-add the main WITHOUT perso props so the order carries no leftover
            // empty Iniciales/_perso_id keys (see rebuildLineWithoutPerso).
            return rebuildLineWithoutPerso(mainItem, persoLine);
          });
        })
          .then(function (data) {
            if (data && data.sections && data.sections[SECTION_ID]) {
              replaceDrawer(data.sections[SECTION_ID]);
              notifyCartUpdated();
            }
            updateCartCount();
            if (fromCartPageRm) window.location.reload();
          })
          .catch(function () {
            removeBtn.removeAttribute('disabled');
            // A failed re-add may have left the main removed; refresh so the
            // drawer reflects the true server state and the customer can retry.
            refreshDrawerFromServer();
            updateCartCount();
          });
        return;
      }

      var toggle = ev.target.closest('[data-cart-pers-toggle]');
      if (toggle) {
        ev.preventDefault();
        var wrapper = toggle.closest('[data-cart-pers]');
        if (!wrapper) return;
        var open = wrapper.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        var form = wrapper.querySelector('[data-cart-pers-form]');
        if (form) form.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (open) {
          var input = wrapper.querySelector('[data-cart-pers-input]');
          if (input) setTimeout(function () { input.focus(); input.select(); }, 220);
        }
        return;
      }

      var cancel = ev.target.closest('[data-cart-pers-cancel]');
      if (cancel) {
        ev.preventDefault();
        var w1 = cancel.closest('[data-cart-pers]');
        if (!w1) return;
        w1.classList.remove('is-open');
        var t1 = w1.querySelector('[data-cart-pers-toggle]');
        if (t1) t1.setAttribute('aria-expanded', 'false');
        var f1 = w1.querySelector('[data-cart-pers-form]');
        if (f1) f1.setAttribute('aria-hidden', 'true');
        var displayValue = w1.parentElement.querySelector('[data-cart-pers-display-value]');
        var stored = displayValue ? (displayValue.textContent || '').replace(/[\u201c\u201d"]/g, '') : '';
        var i1 = w1.querySelector('[data-cart-pers-input]');
        if (i1) i1.value = stored;
        // Multi-piece form: uncheck + collapse + clear every pieza row so a
        // reopened form never posts stale values.
        w1.querySelectorAll('[data-cart-pers-piece]').forEach(function (row) {
          var rc = row.querySelector('[data-cart-pers-piece-check]');
          if (rc) rc.checked = false;
          var rf = row.querySelector('.cart-pers__piece-field');
          if (rf) rf.hidden = true;
          var ri = row.querySelector('[data-cart-pers-piece-input]');
          if (ri) ri.value = '';
          var rcount = row.querySelector('[data-cart-pers-piece-count]');
          if (rcount) rcount.textContent = '0/' + (parseInt(w1.dataset.max, 10) || 6);
        });
        refreshCartPersPiecesTotal(w1);
        var err1 = w1.querySelector('[data-cart-pers-error]');
        if (err1) { err1.hidden = true; err1.textContent = ''; }
        return;
      }

      var save = ev.target.closest('[data-cart-pers-save]');
      if (save) {
        ev.preventDefault();
        var w2 = save.closest('[data-cart-pers]');
        if (!w2) return;
        var input2 = w2.querySelector('[data-cart-pers-input]');
        var err2 = w2.querySelector('[data-cart-pers-error]');
        var key = w2.dataset.lineKey;
        var multiRows = w2.querySelectorAll('[data-cart-pers-piece]');
        if ((!input2 && !multiRows.length) || !key) return;
        var value = '';
        var multiPieces = null;
        if (multiRows.length) {
          // Multi-piece add (coasters/pads/minimalbundle sin perso): collect
          // checked + filled piezas. Mirrors the PDP contract exactly —
          // checked-but-empty rows are ignored; zero armed piezas is a
          // guard error, never a silent single-fee save.
          multiPieces = [];
          var multiRepeat = false;
          multiRows.forEach(function (row) {
            var rowCheck = row.querySelector('[data-cart-pers-piece-check]');
            var rowField = row.querySelector('[data-cart-pers-piece-input]');
            if (!rowCheck || !rowCheck.checked || !rowField) return;
            var rowVal = sanitizePers(rowField.value);
            rowField.value = rowVal;
            if (!rowVal) return;
            if (tooManyRepeats(rowVal)) { multiRepeat = true; return; }
            multiPieces.push({ label: rowField.dataset.pieceLabel || '', value: rowVal });
          });
          if (multiRepeat) {
            if (err2) { err2.hidden = false; err2.textContent = 'Máximo 3 letras iguales por grabado.'; }
            return;
          }
          if (!multiPieces.length) {
            if (err2) { err2.hidden = false; err2.textContent = 'Selecciona al menos una pieza y agrega sus iniciales.'; }
            return;
          }
        } else {
          value = sanitizePers(input2.value);
          input2.value = value;
          if (tooManyRepeats(value)) {
            if (err2) { err2.hidden = false; err2.textContent = 'Máximo 3 letras iguales por grabado.'; }
            return;
          }
        }
        save.setAttribute('disabled', '');
        save.textContent = 'Guardando...';
        var fromCartPageSave = isInCartPage(w2);

        enqueue(function () {
          return getCart().then(function (cart) {
            var mainItem = (cart.items || []).filter(function (it) { return it.key === key; })[0];
            if (!mainItem) throw new Error('line not found');
            var existingPersoId = persoIdOf(mainItem);
            var existingPersoLine = findPersoLine(cart, existingPersoId);
            var mainQty = mainItem.quantity || 1;
            var productTitle = (mainItem.product_title || mainItem.title || '');

            // CASE A (value cleared): behave like Remove. Re-add the main line
            // WITHOUT perso props (rebuildLineWithoutPerso) so a cleared
            // personalización leaves NO empty Iniciales/_perso_id keys on the
            // order (Shopify keeps empty-string properties; a clean re-add is the
            // only way to drop them). Adolfo flagged 2026-06-08.
            if (!multiPieces && !value) {
              return rebuildLineWithoutPerso(mainItem, existingPersoLine);
            }

            // Multi form is only rendered on lines with NO perso yet; if the
            // server says one exists, the DOM is stale — bail instead of
            // double-charging.
            if (multiPieces && existingPersoLine) {
              throw { description: 'Este producto ya tiene personalización. Recarga la página.' };
            }

            // CASE B — personalización already exists: update Iniciales on
            // BOTH the main line and the linked $49 line.
            // After the first changeRequest the line keys MAY rotate in
            // edge cases (Shopify can treat a properties change as a new
            // line). Re-resolve the main line key by re-reading the cart
            // so the followup changeRequest never carries a stale
            // identifier. Spec 2026-05-26 / FIX 4.
            if (existingPersoLine) {
              return changeRequest({
                id: existingPersoLine.key,
                properties: {
                  _perso_id: existingPersoId,
                  Para: productTitle,
                  Iniciales: value
                }
              }).then(function () {
                return getCart();
              }).then(function (freshCart) {
                var freshMain = (freshCart.items || []).filter(function (it) {
                  return it.variant_id === mainItem.variant_id
                    && (!it.handle || it.handle !== 'custom')
                    && persoIdOf(it) === existingPersoId;
                })[0];
                var freshKey = (freshMain && freshMain.key) || key;
                // Same merge rationale as CASE C: /cart/change.js properties
                // REPLACES the hash — keep the line's non-perso properties
                // (Certificado, Set, gift flags) or this edit wipes them.
                var editProps = {};
                var editSource = (freshMain && freshMain.properties) || mainItem.properties || {};
                Object.keys(editSource).forEach(function (pk) {
                  if (pk === 'Iniciales' || pk === '_perso_id' || pk.indexOf('Iniciales ') === 0) return;
                  var pv = editSource[pk];
                  if (pv !== null && pv !== undefined && pv !== '') editProps[pk] = pv;
                });
                editProps.Iniciales = value;
                editProps._perso_id = existingPersoId;
                return changeRequest({
                  id: freshKey,
                  properties: editProps,
                  sections: SECTION_ID
                });
              });
            }

            // CASE C — no personalización yet: add a new $49 line, then set
            // Iniciales + _perso_id on the main line. Multi-piece lines carry
            // one 'Iniciales <Pieza>' key per armed pieza (NO plain
            // Iniciales) and the fee line ships at qty x piezas — the same
            // contract the PDP posts, so persoFactorOf() qty mirroring and
            // the drawer/cart per-piece display work unchanged.
            var newPersoId = makePersoId();
            var feeQty = mainQty;
            var feeProps = { _perso_id: newPersoId, Para: productTitle };
            // /cart/change.js `properties` REPLACES the whole hash, so seed
            // from the line's existing non-perso properties (Certificado,
            // Set, gift flags) or they would be silently wiped by this save.
            var mainPersProps = {};
            if (mainItem.properties) {
              Object.keys(mainItem.properties).forEach(function (pk) {
                if (pk === 'Iniciales' || pk === '_perso_id' || pk.indexOf('Iniciales ') === 0) return;
                var pv = mainItem.properties[pk];
                if (pv !== null && pv !== undefined && pv !== '') mainPersProps[pk] = pv;
              });
            }
            mainPersProps._perso_id = newPersoId;
            if (multiPieces) {
              multiPieces.forEach(function (p) {
                feeProps['Iniciales ' + p.label] = p.value;
                mainPersProps['Iniciales ' + p.label] = p.value;
              });
              feeQty = mainQty * multiPieces.length;
            } else {
              feeProps.Iniciales = value;
              mainPersProps.Iniciales = value;
            }
            return addRequest([{
              id: String(PERSO_VARIANT_ID),
              quantity: feeQty,
              properties: feeProps
            }], false).then(function (addData) {
              // Re-resolve the main line key from the FULL post-add cart so
              // the followup changeRequest never carries a stale identifier
              // (the line key the user opened the form with may have rotated
              // if the line was touched between open and save — variant
              // swap, qty change, external mutation). /cart/add.js's
              // response only returns the just-added items (the new $49
              // perso line) — NOT the full cart — so we must call /cart.js
              // to look up the main line. Prefer the original `key` if it
              // still exists; otherwise fall back to the first line matching
              // variant_id + no _perso_id + handle !== 'custom'. Spec
              // 2026-05-26 / FIX 4 (corrected after QA).
              //
              // CRITICAL: use a raw /cart.js fetch here (NOT getCart()).
              // getCart() runs cleanOrphanPersoLines() which would see the
              // perso line we just added — but the main line does NOT yet
              // carry the matching _perso_id (we're about to set it in the
              // very next step). The sweep would misidentify the new perso
              // as orphan and REMOVE it, leaving the customer's cart with
              // only the main line + Iniciales property + no $49 perso
              // line at checkout. Adolfo flagged 2026-05-26: cart shows
              // "Custom: AM" on main but no perso line, no +$49 badge, and
              // checkout charges only the main item.
              return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (freshCart) {
                var freshItems = (freshCart && freshCart.items) || [];
                var stillExact = freshItems.filter(function (it) { return it.key === key; })[0];
                var freshKey = key;
                if (!stillExact) {
                  var candidate = freshItems.filter(function (it) {
                    return it.variant_id === mainItem.variant_id
                      && (!it.handle || it.handle !== 'custom')
                      && !persoIdOf(it);
                  })[0];
                  if (candidate) {
                    freshKey = candidate.key;
                  } else {
                    throw { description: 'No pudimos encontrar el producto en el carrito. Recarga la página.' };
                  }
                }
                return changeRequest({
                  id: freshKey,
                  properties: mainPersProps,
                  sections: SECTION_ID
                });
              }).catch(function (changeErr) {
                // Orphan guard: the $49 line was added but linking it to
                // the main line failed. That line carries handle `custom`,
                // so it is hidden from every drawer/cart render loop — the
                // customer cannot see or remove it, yet it IS in
                // cart.total_price and would reach checkout as a silent
                // $49 overcharge. Locate it in the add response by its
                // _perso_id and roll it back with a compensating qty-0
                // change, then re-throw so the outer .catch reports the
                // original failure to the customer. Spec 2026-05-20 / BL-3(c).
                var orphan = (addData && addData.items || []).filter(function (it) {
                  return it.properties && it.properties._perso_id === newPersoId;
                })[0];
                if (orphan) {
                  return changeRequest({ id: orphan.key, quantity: 0 })
                    .catch(function (rollbackErr) {
                      // Rollback itself failed — log it; still surface the
                      // original error so the customer is not left thinking
                      // the save succeeded.
                      console.error('[cart-drawer] perso orphan rollback failed', rollbackErr);
                    })
                    .then(function () { throw changeErr; });
                }
                throw changeErr;
              });
            });
          });
        })
          .then(function (data) {
            if (data && data.sections && data.sections[SECTION_ID]) {
              replaceDrawer(data.sections[SECTION_ID]);
              notifyCartUpdated();
            }
            updateCartCount();
            if (fromCartPageSave) window.location.reload();
          })
          .catch(function (err) {
            // Detect Shopify's stale-identifier error ("Identificación o
            // parámetro lineal no válidos" / "Invalid identifier or line
            // parameter"). The drawer markup is out of sync with the
            // server cart — refresh from the section-rendering API so the
            // next save attempt uses fresh keys. Spec 2026-05-26 / FIX 4.
            // Belt-and-suspenders: also fire on HTTP 404 from /cart/change.js
            // (Shopify's status code for an unknown line key) since locale
            // text translations may drift.
            var identifierError = err && (
              err.status === 404
              || (err.description && /no v[áa]lidos|invalid (identifier|line|request)/i.test(err.description))
            );
            var friendlyMessage = identifierError
              ? 'El carrito cambió. Lo refrescamos. Intenta personalizar de nuevo.'
              : ((err && err.description) ? err.description : 'No se pudo guardar. Intenta de nuevo.');
            if (err2) {
              err2.hidden = false;
              err2.textContent = friendlyMessage;
            }
            save.removeAttribute('disabled');
            save.textContent = 'Guardar';
            if (identifierError) {
              refreshDrawerFromServer();
            }
          });
        return;
      }
    });

    document.addEventListener('input', function (ev) {
      var input = ev.target.closest('[data-cart-pers-input]');
      if (!input) return;
      var wrapper = input.closest('[data-cart-pers]');
      if (!wrapper) return;
      var max = parseInt(wrapper.dataset.max, 10) || 6;
      var cleaned = sanitizePers(input.value);
      if (cleaned !== input.value) input.value = cleaned;
      var count = wrapper.querySelector('[data-cart-pers-count]');
      if (count) count.textContent = input.value.length + '/' + max;
      var err = wrapper.querySelector('[data-cart-pers-error]');
      if (err) {
        if (tooManyRepeats(input.value)) {
          err.hidden = false; err.textContent = 'Máximo 3 letras iguales por grabado.';
        } else {
          err.hidden = true; err.textContent = '';
        }
      }
    });

    // Multi-piece rows: sanitize + per-row counter (same rules as the
    // single input above, scoped to the pieza's own row).
    document.addEventListener('input', function (ev) {
      var pinput = ev.target.closest('[data-cart-pers-piece-input]');
      if (!pinput) return;
      var wrapper = pinput.closest('[data-cart-pers]');
      var row = pinput.closest('[data-cart-pers-piece]');
      if (!wrapper || !row) return;
      var max = parseInt(wrapper.dataset.max, 10) || 6;
      var cleaned = sanitizePers(pinput.value);
      if (cleaned !== pinput.value) pinput.value = cleaned;
      var count = row.querySelector('[data-cart-pers-piece-count]');
      if (count) count.textContent = pinput.value.length + '/' + max;
      var err = wrapper.querySelector('[data-cart-pers-error]');
      if (err) {
        if (tooManyRepeats(pinput.value)) {
          err.hidden = false; err.textContent = 'Máximo 3 letras iguales por grabado.';
        } else {
          err.hidden = true; err.textContent = '';
        }
      }
    });

    // Multi-piece rows: checkbox arms/collapses its pieza field and drives
    // the 'Total grabado' rollup, mirroring the PDP behavior.
    document.addEventListener('change', function (ev) {
      var check = ev.target.closest('[data-cart-pers-piece-check]');
      if (!check) return;
      var wrapper = check.closest('[data-cart-pers]');
      var row = check.closest('[data-cart-pers-piece]');
      if (!wrapper || !row) return;
      var field = row.querySelector('.cart-pers__piece-field');
      var finput = row.querySelector('[data-cart-pers-piece-input]');
      if (check.checked) {
        if (field) field.hidden = false;
        if (finput) setTimeout(function () { finput.focus(); }, 120);
      } else {
        if (field) field.hidden = true;
        if (finput) finput.value = '';
        var count = row.querySelector('[data-cart-pers-piece-count]');
        if (count) count.textContent = '0/' + (parseInt(wrapper.dataset.max, 10) || 6);
      }
      refreshCartPersPiecesTotal(wrapper);
    });
  }

  // 'Total grabado: +$N' rollup for a multi-piece cart-pers form. N =
  // checked piezas x per-piece price parsed from the wrapper's
  // data-price-label ('$49' / '$49 MXN' merchant copy).
  function refreshCartPersPiecesTotal(wrapper) {
    var totalEl = wrapper.querySelector('[data-cart-pers-pieces-total]');
    if (!totalEl) return;
    var n = 0;
    wrapper.querySelectorAll('[data-cart-pers-piece-check]').forEach(function (c) {
      if (c.checked) n++;
    });
    var price = parseFloat(String(wrapper.dataset.priceLabel || '').replace(/[^0-9.]/g, '')) || 0;
    if (n > 0 && price > 0) {
      totalEl.textContent = 'Total grabado: +$' + (n * price);
      totalEl.hidden = false;
    } else {
      totalEl.hidden = true;
    }
  }

  function wireVariantSwap() {
    // Cart line variant picker (color / model). Renders as a <select>
    // on items whose product has more than one variant. On change, we
    // remove the old line and re-add the new variant, preserving qty
    // and line item properties (e.g. personalization "Iniciales").
    document.addEventListener('change', function (ev) {
      var sel = ev.target.closest('[data-cart-variant-change]');
      if (!sel) return;
      var newVariantId = sel.value;
      var lineKey = sel.dataset.lineKey;
      if (!newVariantId || !lineKey) return;

      var line = sel.closest('[data-cart-line]');
      var fromCartPage = isInCartPage(sel);

      sel.setAttribute('disabled', '');
      if (line) line.classList.add('is-swapping');

      // Serialize the WHOLE swap through enqueue() so the orphan sweep
      // (cleanOrphanPersoLines, fired by any getCart() from open/pageshow/
      // visibilitychange/qty/edit) can NEVER interleave between the remove and
      // the re-add. The old code used raw fetch OUTSIDE the queue: it removed
      // the main line, and in the gap before the re-add a concurrent sweep saw
      // the linked $49 personalización line as an orphan and deleted it -- the
      // re-added main kept _perso_id + Iniciales but lost its paired $49 line,
      // so the customer was never charged. Confirmed + reproduced on orders
      // LE1262 / LE1263 (2026-06-02..05). For a personalized line we rebuild
      // the perso PAIR atomically: remove the old main + old $49 line, then add
      // BOTH the new variant main and a fresh $49 line under ONE new _perso_id
      // in a single /cart/add.js items[] call. See
      // feedback_shopify_perso_orphan_lines.md.
      enqueue(function () {
        return getCart().then(function (cart) {
          var oldItem = (cart.items || []).filter(function (it) { return it.key === lineKey; })[0];
          if (!oldItem) throw new Error('line not found');

          var oldQty = oldItem.quantity || 1;
          var oldPersoId = persoIdOf(oldItem);
          var oldPersoLine = oldPersoId ? findPersoLine(cart, oldPersoId) : undefined;

          // Carry over every property EXCEPT the perso link (_perso_id is
          // regenerated below so the rebuilt pair shares one fresh id).
          var carriedProps = {};
          if (oldItem.properties) {
            Object.keys(oldItem.properties).forEach(function (k) {
              if (k === '_perso_id') return;
              var val = oldItem.properties[k];
              if (val !== null && val !== undefined && val !== '') carriedProps[k] = val;
            });
          }

          if (oldPersoLine) {
            var newPersoId = makePersoId();
            var iniciales = carriedProps.Iniciales
              || (oldPersoLine.properties && oldPersoLine.properties.Iniciales) || '';
            var productTitle = (oldPersoLine.properties && oldPersoLine.properties.Para)
              || oldItem.product_title || oldItem.title || '';
            var mainProps = { _perso_id: newPersoId };
            Object.keys(carriedProps).forEach(function (k) { mainProps[k] = carriedProps[k]; });
            // Only write Iniciales when truthy: Shopify keeps empty-string
            // property keys, and a multi-piece line (per-piece keys
            // 'Iniciales <Pieza>', already preserved via carriedProps) must
            // never gain a plain empty `Iniciales` key on the rebuild.
            if (iniciales) mainProps.Iniciales = iniciales;

            // Rebuilt $49 line: Para + the single Iniciales (when set) PLUS
            // every per-piece 'Iniciales <Pieza>' key carried from the OLD
            // $49 line, preserving the multi-piece qty factor below.
            var rebuiltPersoProps = { _perso_id: newPersoId, Para: productTitle };
            if (iniciales) rebuiltPersoProps.Iniciales = iniciales;
            if (oldPersoLine.properties) {
              Object.keys(oldPersoLine.properties).forEach(function (k) {
                if (k.indexOf('Iniciales ') !== 0) return;
                var pieceVal = oldPersoLine.properties[k];
                if (pieceVal !== null && pieceVal !== undefined && pieceVal !== '') rebuiltPersoProps[k] = pieceVal;
              });
            }

            // Remove old main, then old $49 line (both inside this one enqueued
            // task -- no sweep runs between them), then atomic re-add of both.
            return changeRequest({ id: lineKey, quantity: 0 })
              .then(function () { return changeRequest({ id: oldPersoLine.key, quantity: 0 }); })
              .then(function () {
                return addRequest([
                  { id: newVariantId, quantity: oldQty, properties: mainProps },
                  {
                    id: String(PERSO_VARIANT_ID),
                    quantity: oldQty * persoFactorOf(oldItem),
                    properties: rebuiltPersoProps
                  }
                ], true);
              });
          }

          // No personalización: remove old, add new with carried props.
          return changeRequest({ id: lineKey, quantity: 0 })
            .then(function () {
              return addRequest([
                { id: newVariantId, quantity: oldQty, properties: carriedProps }
              ], true);
            });
        });
      })
        .then(function (data) {
          if (fromCartPage) {
            window.location.reload();
            return;
          }
          if (data && data.sections && data.sections[SECTION_ID]) {
            replaceDrawer(data.sections[SECTION_ID]);
            notifyCartUpdated();
          }
          updateCartCount();
        })
        .catch(function (err) {
          console.error('[cart-drawer] variant swap failed', err);
          sel.removeAttribute('disabled');
          if (line) line.classList.remove('is-swapping');
          var msg = (err && err.description) || (err && err.message) || 'No se pudo cambiar la variante.';
          alert(msg);
        });
    });
  }

  // ---- Discount code -------------------------------------------------
  // Apply a discount code from the cart drawer or cart page WITHOUT a
  // full-page navigation, and show inline feedback. The old inline
  // handlers set window.location to /discount/<code>, which silently
  // reloaded with no feedback when the code was invalid.
  //
  // The status is JS-driven on purpose: fetch('/discount/<code>') sets
  // Shopify's discount cookie, then we read /cart.js, whose
  // discount_codes array carries { code, applicable } for the entered
  // code. Liquid's cart.discount_codes does NOT surface a non-applicable
  // code, so an invalid code can only be detected here, from /cart.js.
  // Document-level delegation survives drawer re-renders. Spec 2026-05-21.
  function wireDiscountForm() {
    // The discount controls are <div>s, not <form>s: a <form> nested in
    // the cart page's outer <form id="cart"> is invalid HTML and gets
    // dropped by the parser. So apply on the Aplicar button click and on
    // Enter in the input, both document-delegated so they survive the
    // drawer re-render.
    document.addEventListener('click', function (ev) {
      var btn = ev.target && ev.target.closest
        ? ev.target.closest('[data-cart-discount-apply]')
        : null;
      if (!btn) return;
      ev.preventDefault();
      var wrap = btn.closest('[data-cart-discount-form], [data-cart-page-discount-form]');
      if (wrap) applyDiscount(wrap);
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Enter') return;
      var input = ev.target;
      if (!input || !input.matches ||
          !input.matches('input[name="discount_code"]')) return;
      var wrap = input.closest('[data-cart-discount-form], [data-cart-page-discount-form]');
      if (!wrap) return;
      ev.preventDefault();
      applyDiscount(wrap);
    });
    // After a cart-page reload triggered by a discount apply, surface the
    // result that was stashed just before the reload.
    consumeStashedDiscountResult();
  }

  // Case-insensitive lookup of a code in a /cart.js discount_codes array.
  function findDiscountEntry(cart, code) {
    var list = (cart && cart.discount_codes) || [];
    var needle = code.toUpperCase();
    for (var i = 0; i < list.length; i++) {
      if (list[i] && String(list[i].code || '').toUpperCase() === needle) {
        return list[i];
      }
    }
    return null;
  }

  function applyDiscount(wrap) {
    var input = wrap.querySelector('input[name="discount_code"]');
    var code = (input && input.value || '').trim();
    if (!code) return;

    var btn = wrap.querySelector('[data-cart-discount-apply]');
    var onCartPage = isInCartPage(wrap);
    if (btn) {
      btn.setAttribute('disabled', '');
      btn.textContent = 'Aplicando...';
    }

    // 1) GET /discount/<code> sets Shopify's discount session cookie.
    //    fetch() sends same-origin cookies and applies the Set-Cookie
    //    response; the redirected HTML body is intentionally ignored.
    // 2) Read /cart.js to learn whether the code is applicable.
    fetch('/discount/' + encodeURIComponent(code), { headers: { 'Accept': 'text/html' } })
      .then(function (r) {
        if (!r.ok) throw new Error('discount endpoint returned ' + r.status);
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js returned ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        var entry = findDiscountEntry(cart, code);
        var state = (entry && entry.applicable) ? 'applied' : 'invalid';
        if (onCartPage) {
          // Cart page reloads (consistent with its quantity /
          // personalización handlers) so the order summary reflects a
          // valid discount. Stash the result so it survives the reload.
          stashDiscountResult(state, code);
          window.location.reload();
          return;
        }
        // Drawer: re-render so the subtotal reflects a valid discount,
        // then write the status into the freshly rendered drawer.
        return refreshDrawerSection().then(function () {
          showDiscountStatus(
            document.querySelector('[data-cart-drawer] [data-cart-discount]'),
            state, code);
        });
      })
      .catch(function (err) {
        console.error('[cart-drawer] discount apply failed', err);
        if (btn) {
          btn.removeAttribute('disabled');
          btn.textContent = 'Aplicar';
        }
        showDiscountStatus(
          wrap.closest('[data-cart-discount], [data-cart-page-discount]'),
          'error', code);
      });
  }

  // Re-fetch + swap the cart drawer section. Unlike refreshDrawerFromServer
  // (which swallows errors for the line-change recovery path), this REJECTS
  // on failure so applyDiscount() can surface the retry message.
  function refreshDrawerSection() {
    return fetch('/?sections=' + SECTION_ID, {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('section render returned ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data || !data[SECTION_ID]) {
          throw new Error('section payload missing ' + SECTION_ID);
        }
        replaceDrawer(data[SECTION_ID]);
        notifyCartUpdated();
      });
  }

  // Write the discount result into a control's status <p>: open the
  // <details> so the message is visible, then set the text. The <p> is
  // an aria-live region, so the change is announced. state is one of
  // 'applied' | 'invalid' | 'error'.
  function showDiscountStatus(details, state, code) {
    if (!details) return;
    if (details.tagName === 'DETAILS') details.setAttribute('open', '');
    var box = details.querySelector('[data-cart-discount-status]');
    if (!box) return;
    var msg;
    if (state === 'applied') {
      msg = 'Código ' + code + ' aplicado.';
    } else if (state === 'invalid') {
      msg = 'Descuento no válido.';
    } else {
      msg = 'No se pudo aplicar el código, intenta de nuevo.';
    }
    box.setAttribute('data-cart-discount-status', state);
    box.textContent = msg;
  }

  // A cart-page apply reloads the page; stash the outcome so the reloaded
  // page can show it. sessionStorage survives a same-tab reload.
  function stashDiscountResult(state, code) {
    try {
      sessionStorage.setItem('le_discount_result',
        JSON.stringify({ state: state, code: code }));
    } catch (e) {}
  }

  function consumeStashedDiscountResult() {
    var raw = null;
    try {
      raw = sessionStorage.getItem('le_discount_result');
      if (raw) sessionStorage.removeItem('le_discount_result');
    } catch (e) { return; }
    if (!raw) return;
    var data = null;
    try { data = JSON.parse(raw); } catch (e) { return; }
    if (!data || !data.state) return;
    showDiscountStatus(document.querySelector('[data-cart-page-discount]'),
      data.state, data.code || '');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
